module.exports = __webpack_public_path__ + "img/bonus.49a6f68c.svg";